<div mat-dialog-title class="flex">
  <h2>Upload Multiple Properties</h2>
  <app-close-button></app-close-button>
</div>

<mat-dialog-content class="pl-2 pr-4">
    <!-- Instructions -->
    <ol class="numbered-list">
      <li class="step number">
        <button type="button" class="btn waves-dark custom btn-secondary" (click)="downloadTemplate()">Download template</button>
      </li>

      <li class="step number">
        Fill in properties data and save spreadsheet in CSV format.<br>
        Note: Columns marked with red * in the header are mandatory.
      </li>

      <li class="step number">
        <button type="button" class="btn waves-dark custom btn-secondary mr-1" (click)="fileInput.click()">Select CSV file</button> to load properties
        <input #fileInput type="file" id="file" accept=".csv" (change)="loadPropertiesFrom($event.target)" style="visibility: hidden">

        <!-- File Summary -->
        <div *ngIf="selectedFile && summary" class="summary mt-2">
          <div>File: {{selectedFile.name}}</div>
          <div>Rows: {{summary.rows}}</div>
          <div *ngIf="summary.rows">Parsed: {{summary.parsed}}</div>
          <div *ngIf="summary.invalid" class="highlight-red">Invalid: {{summary.invalid}}</div>
        </div>

        <!-- Duplicates -->
        <div *ngIf="summary.duplicates" class="duplicates mt-2">
          <div class="highlight-red">Duplicates: {{summary.duplicates}}</div>
          <div *ngFor="let email of duplicates; let idx=index" class="highlight-red">{{ idx + 1 }}: {{email}}</div>
        </div>

        <!-- Validation Errors -->
        <div *ngIf="summary.errors" class="errors mt-2">
          <div class="highlight-red">Errors: {{summary.errors}}</div>
          <div *ngFor="let error of errors; let idx=index" class="highlight-red">{{ idx + 1 }}: {{error}}</div>
        </div>

        <!-- Error -->
        <div *ngIf="error" class="error invalid mt-2">
          {{error}}
        </div>
      </li>

      <li class="step number" [class.disabled]="!enableUpload">
        Hit Upload button below once ready.
      </li>
    </ol>
    </mat-dialog-content>

<mat-dialog-actions class="pb-3">
    <button mat-button class="mat-raised-button" (click)="close()">Close</button>
    <button mat-button class="mat-raised-button ml-1" color="primary" (click)="upload()" [disabled]="!enableUpload">Upload</button>
</mat-dialog-actions>
